import { render, staticRenderFns } from "./RadiobuttonsInput.vue?vue&type=template&id=f76d2064&"
import script from "./RadiobuttonsInput.vue?vue&type=script&lang=js&"
export * from "./RadiobuttonsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports